/**
 * Ryan O'Dowd
 * 2025-06-08
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    disabled: {
      backgroundColor: `${colors.disabled}44`,
    },
  };
};

export default getStyles;
